import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router';
import RestaurantLayout from '../../components/Restaurant/RestaurantLayout';
import BonusQrCodeReader from '../../components/Bonus/BonusQrCodeReader';
import bonusProductAPI from '../../middleware/bonusProductAPI';
import AssignmentRoundedIcon from '@material-ui/icons/AssignmentRounded';
import DoneRoundedIcon from '@material-ui/icons/DoneRounded';
import ClearRoundedIcon from '@material-ui/icons/ClearRounded';
import ConfirmationNumberRoundedIcon from '@material-ui/icons/ConfirmationNumberRounded';
import PermContactCalendarRoundedIcon from '@material-ui/icons/PermContactCalendarRounded';
import { Button, Divider, Step, StepLabel, Stepper } from '@material-ui/core';
import Swal from 'sweetalert2';
import { isArray, join, filter, map } from 'lodash';
import CardTravelRoundedIcon from '@material-ui/icons/CardTravelRounded';

const STEPS = [
  {
    key: 'group',
    name: '打包QRCODE',
  },
  {
    key: 'product',
    name: '紙本QRCODE',
  },
];

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#fff',
    padding: theme.spacing(3),
    maxWidth: '500px',
    margin: theme.spacing(0, 'auto'),
    borderRadius: theme.spacing(0.5),
  },
  block: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    alignItems: 'stretch',
    gap: theme.spacing(2),
  },
  title: {
    fontSize: '1.2rem',
    fontWeight: 'bold',
    marginBottom: theme.spacing(2),
  },
  titleSubText: {
    fontSize: '0.9rem',
    color: theme.palette.text.secondary,
  },
  subTitle: {
    fontSize: '1.1rem',
    fontWeight: '600',
    margin: theme.spacing(1, 0),
    color: '#8b8b8b',
    display: 'flex',
    flexWrap: 'nowrap',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  scanRsCounts: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'stretch',
    gap: theme.spacing(2),
    backgroundColor: '#eee',
    padding: theme.spacing(2),
    borderRadius: theme.spacing(1),
  },
  scanRs: {
    flexGrow: 1,
    flexBasis: '100%',
    overflowY: 'auto',
    maxHeight: '200px',
  },
  scanRsContent: {
    margin: theme.spacing(1, 0),
    fontSize: '0.8rem',
    fontWeight: '500',
    lineHeight: '1.5',
  },
  scanRsSuccess: {
    padding: theme.spacing(1),
    margin: theme.spacing(1, 0),
    borderRadius: theme.spacing(0.5),
    backgroundColor: '#6b936b',
    color: '#fff',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  scanRsError: {
    padding: theme.spacing(1),
    margin: theme.spacing(1, 0),
    borderRadius: theme.spacing(0.5),
    backgroundColor: '#e35858',
    color: '#fff',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  stepBtns: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(1),
    justifyContent: 'space-evenly',
    margin: theme.spacing(2, 0, 0),
  },
}));

const GroupBonusProductQRCode = () => {
  const classes = useStyles();
  const history = useHistory();
  const [activeStep, setActiveStep] = useState(0);
  const [nowStep, setNowStep] = useState();
  const [isLoading, setIsLoading] = React.useState(false);
  const [groupQRCode, setGroupQRCode] = useState('');
  const [scanQRCode, setScanQRCode] = React.useState('');
  const [scanRs, setScanRs] = React.useState([]);

  useEffect(() => {
    setNowStep(STEPS[activeStep]);
  }, [activeStep]);

  useEffect(() => {
    if (groupQRCode) {
      setActiveStep(activeStep + 1);
    }
  }, [groupQRCode]);

  useEffect(() => {
    if (scanQRCode) {
      setIsLoading(true);

      bonusProductAPI
        .groupQRCode(groupQRCode, scanQRCode)
        .then(
          (rs) => {
            let newScanRs = [...scanRs];

            newScanRs.unshift({
              status: 'success',
              message: `加入成功 ${scanQRCode}`,
            });

            setScanRs(newScanRs);

            Swal.fire({
              toast: true,
              position: 'bottom',
              icon: 'success',
              title: `加入成功 ${scanQRCode}`,
              timer: 1000,
              showConfirmButton: false,
            });
          },
          (error) => {
            const errorMessage = isArray(error.messages)
              ? join(error.messages, '<br />')
              : error;
            let newScanRs = [...scanRs];

            newScanRs.unshift({
              status: 'error',
              message: `加入失敗 ${scanQRCode}`,
              error: errorMessage,
            });

            setScanRs(newScanRs);

            Swal.fire({
              toast: true,
              position: 'bottom',
              icon: 'error',
              title: `加入失敗 ${scanQRCode}`,
              timer: 1000,
              showConfirmButton: false,
            });
          },
        )
        .then(() => {
          setIsLoading(false);
          setScanQRCode('');
        });
    }
  }, [scanQRCode]);

  const handleChangeScanQRCode = (qrcodeData) => {
    if (qrcodeData) {
      setScanQRCode(qrcodeData);
    }
  };

  const handleChangeScanGroupQRCode = (qrcodeData) => {
    if (qrcodeData) {
      setGroupQRCode(qrcodeData);
    }
  };

  const handleClickDoneStep = () => {
    history.push('/bonus');
  };

  return (
    <RestaurantLayout
      showBackBtn
      hideLogo={nowStep && nowStep.key === 'product'}>
      <div className={classes.root}>
        <Stepper activeStep={activeStep} alternativeLabel>
          {map(STEPS, (step) => (
            <Step key={step.key}>
              <StepLabel>{step.name}</StepLabel>
            </Step>
          ))}
        </Stepper>

        {nowStep && nowStep.key === 'group' && (
          <div className={classes.block}>
            <div className={classes.title}>打包 QRCODE</div>

            <div>
              <BonusQrCodeReader
                hideTitle
                isLoading={isLoading}
                verifyQrcodeData={handleChangeScanGroupQRCode}
              />
            </div>
          </div>
        )}

        {nowStep && nowStep.key === 'product' && (
          <div className={classes.block}>
            <div className={classes.title}>
              加入打包
              <div className={classes.titleSubText}>
                多張使用時，可等待掃描結果出現後再繼續掃描下一張
              </div>
            </div>

            <div>
              <BonusQrCodeReader
                hideTitle
                isLoading={isLoading}
                verifyQrcodeData={handleChangeScanQRCode}
              />
            </div>

            <div>
              <div className={classes.subTitle}>
                <AssignmentRoundedIcon />
                目前掃描結果
              </div>

              <div className={classes.scanRsCounts}>
                <div>
                  <div>
                    <ConfirmationNumberRoundedIcon />
                  </div>
                  <div>全部 {scanRs.length} 筆</div>
                </div>

                <Divider orientation="vertical" flexItem />

                <div>
                  <div>
                    <DoneRoundedIcon />
                  </div>
                  <div>
                    成功{' '}
                    {filter(scanRs, (rs) => rs.status === 'success').length} 筆
                  </div>
                </div>

                <Divider orientation="vertical" flexItem />

                <div>
                  <div>
                    <ClearRoundedIcon />
                  </div>
                  <div>
                    失敗 {filter(scanRs, (rs) => rs.status === 'error').length}{' '}
                    筆
                  </div>
                </div>

                <div className={classes.scanRs}>
                  <Divider variant="middle" />

                  <div className={classes.scanRsContent}>
                    {scanRs.map((scan, index) => (
                      <div
                        key={index}
                        className={
                          scan.status === 'success'
                            ? classes.scanRsSuccess
                            : classes.scanRsError
                        }>
                        {scan.status === 'success' ? (
                          <DoneRoundedIcon />
                        ) : (
                          <ClearRoundedIcon />
                        )}

                        {scan.message}
                        {scan.error && <div>{scan.error}</div>}
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {groupQRCode && (
                <>
                  <div className={classes.subTitle}>
                    <CardTravelRoundedIcon />
                    打包QRCODE
                  </div>

                  <div className={classes.scanRsCounts}>
                    <div>{groupQRCode}</div>
                  </div>
                </>
              )}
            </div>
          </div>
        )}

        <div className={classes.stepBtns}>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={handleClickDoneStep}>
            結束
          </Button>
        </div>
      </div>
    </RestaurantLayout>
  );
};

export default GroupBonusProductQRCode;
